// extracted by mini-css-extract-plugin
module.exports = {"container":"SurveysContainer_container__1Sg3B","title":"SurveysContainer_title__2m0UM"};